import { createFragmentContainer, graphql } from 'react-relay';
import Recommendation from './';

export default createFragmentContainer(Recommendation, {
  node: graphql`
    fragment RecommendationContainer_node on Playlist {
      id
      title
      description
      thumbnail(width: 240, height: 240) {
        url
        width
        height
      }
      playlist_songs(first: 99999)
        @connection(key: "UserPlaylistContainer_playlist_songs") {
        edges {
          node {
            id
            position
            song {
              __typename
              id
              isrc
              name
              album
              artist
              song_images {
                edges {
                  node {
                    id
                    url
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
    }
  `
});



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Recommendation/RecommendationContainer.js